import { render } from "./WalletInfoModal.vue?vue&type=template&id=5f5b0728&scoped=true"
import script from "./WalletInfoModal.vue?vue&type=script&lang=js"
export * from "./WalletInfoModal.vue?vue&type=script&lang=js"

import "./WalletInfoModal.vue?vue&type=style&index=0&id=5f5b0728&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/wildwestgame/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5b0728"]])

export default __exports__